import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

let socket = null;

export function getSocket() {
  if (!socket) {
    const base = process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL.replace('/api', '')
      : 'http://localhost:5000';
    const token = localStorage.getItem('token') || '';
    socket = io(base, {
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      auth: { token },   // sent in handshake, verified by server middleware
    });
  }
  return socket;
}

/** Call on logout so the next login gets a fresh authenticated socket. */
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function useSocket(userId) {
  const socketRef = useRef(null);

  useEffect(() => {
    const s = getSocket();
    socketRef.current = s;
    if (userId) {
      s.emit('join', userId);
    }
    return () => {
      // Don't disconnect — keep persistent connection
    };
  }, [userId]);

  return socketRef.current;
}
